import { default as React, FunctionComponent, useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import useThunkDispatch from '../useThunkDispatch'
import { useSelector } from 'react-redux'
import { find, isEmpty } from 'lodash/fp'

import { accountsDictSelector } from '../../accounts/accountsSelectors'
import { requestAccounts } from '../../accounts/accountsActions'

const ClientBranchBreadcrumb: FunctionComponent = () => {
  const { accountId, '*': rest } = useParams()
  const branchId = rest?.match(/^branches\/(\d+)/)?.[1]
  const navigate = useNavigate()

  const dispatch = useThunkDispatch()
  const accounts = useSelector(accountsDictSelector)

  useEffect(() => {
    if (isEmpty(accounts) && accountId)
      dispatch(requestAccounts({ accountId: parseInt(accountId, 10) }))
  }, [])

  const account = accountId ? accounts[accountId] : undefined
  const branch =
    branchId && account && find({ id: Number(branchId) }, account.branches)

  if (account)
    return (
      <nav className="breadcrumb">
        <div className="breadcrumb_item">
          <button
            className="clear-button breadcrumb_button"
            onClick={() => navigate(`/clients/${accountId}`)}
          >
            {account.name}
          </button>
        </div>
        {branch && <div className="breadcrumb_item">{branch.name}</div>}
      </nav>
    )

  return null
}

export default ClientBranchBreadcrumb
